export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Facebook', url: '/facebook', icon: 'FacebookIcon', is_bookmarked: true},
      {title: 'Youtube', url: '/youtube', icon: 'YoutubeIcon', is_bookmarked: true},
      {title: 'Instagram', url: '/instagram', icon: 'InstagramIcon', is_bookmarked: true},
    ]
  }
}
